var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutCompnyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_14294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47852 17C7.02852 17 7.47852 16.55 7.47852 16V11C7.47852 10.45 7.02852 10 6.47852 10C5.92852 10 5.47852 10.45 5.47852 11V16C5.47852 16.55 5.92852 17 6.47852 17Z",
    fill: "#4C60E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4785 17C13.0285 17 13.4785 16.55 13.4785 16V11C13.4785 10.45 13.0285 10 12.4785 10C11.9285 10 11.4785 10.45 11.4785 11V16C11.4785 16.55 11.9285 17 12.4785 17Z",
    fill: "#4C60E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7985 5.66023L13.3785 1.45023C12.8185 1.17023 12.1485 1.17023 11.5885 1.45023L3.15852 5.66023C2.73852 5.87023 2.47852 6.30023 2.47852 6.76023C2.47852 7.45023 3.02852 8.00023 3.71852 8.00023H21.2485C21.9285 8.00023 22.4785 7.45023 22.4785 6.76023C22.4785 6.30023 22.2185 5.87023 21.7985 5.66023Z",
    fill: "#4C60E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47852 20C2.47852 20.55 2.92852 21 3.47852 21H14.8785C14.6685 20.36 14.5585 19.69 14.5185 19H3.47852C2.92852 19 2.47852 19.45 2.47852 20Z",
    fill: "#4C60E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4785 12.26V11C19.4785 10.45 19.0285 10 18.4785 10C17.9285 10 17.4785 10.45 17.4785 11V13.26L19.4785 12.26Z",
    fill: "#4C60E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0285 14.221L17.0285 15.721C16.6885 15.891 16.4785 16.241 16.4785 16.621V18.551C16.4785 21.071 18.1885 23.431 20.4785 24.001C22.7685 23.431 24.4785 21.071 24.4785 18.551V16.621C24.4785 16.241 24.2685 15.891 23.9285 15.731L20.9285 14.231C20.6485 14.081 20.3085 14.081 20.0285 14.221ZM19.0585 20.301L18.2585 19.501C17.9685 19.211 17.9685 18.731 18.2585 18.441C18.5485 18.151 19.0285 18.151 19.3185 18.441L19.7585 18.881L21.6385 17.031C21.9285 16.741 22.4085 16.741 22.6985 17.031C22.9885 17.321 22.9885 17.801 22.6985 18.091L20.4685 20.301C20.0785 20.691 19.4485 20.691 19.0585 20.301Z",
    fill: "#4C60E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_14294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutCompnyBlue);
export default __webpack_public_path__ + "static/media/aboutCompnyBlue.af8910c13b92f3ed6a2decf8d3c44a8b.svg";
export { ForwardRef as ReactComponent };